import React from "react";
import { Box, useTheme } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

interface GlassCardProps {
  /** dark = frosted glass on navy/gradient sections, light = on pale sections */
  tone?: "dark" | "light";
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

const GlassCard: React.FC<GlassCardProps> = ({ tone = "light", sx, children }) => {
  const theme = useTheme();
  const glass = theme.custom.glass;

  return (
    <Box
      sx={[
        {
          borderRadius: theme.custom.borderRadius,
          p: 3,
          backdropFilter: glass.blur,
          WebkitBackdropFilter: glass.blur,
          ...(tone === "dark"
            ? {
                backgroundColor: glass.background,
                border: glass.border,
                color: "common.white",
              }
            : {
                backgroundColor: glass.backgroundLight,
                border: glass.borderLight,
                boxShadow: "0 4px 18px rgba(19,41,63,0.06)",
              }),
          transition: "transform 0.25s ease, box-shadow 0.25s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow:
              tone === "dark"
                ? "0 12px 28px rgba(0,0,0,0.35)"
                : "0 12px 28px rgba(19,41,63,0.12)",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
};

export default GlassCard;
